/* Publish by EComposer at 2026-10-21 06:35:12*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-bfuvcw3exqn"]=  window.__ectimmers["ecom-bfuvcw3exqn"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-bfuvcw3exqn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bfuvcw3exqn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lxywvatpj1i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lxywvatpj1i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ozwvjumqxhk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ozwvjumqxhk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uxepr7rh49').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uxepr7rh49', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0p5v19qoh6dc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0p5v19qoh6dc', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rl8zheqs74c"]=  window.__ectimmers["ecom-rl8zheqs74c"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(i.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-rl8zheqs74c"]["1m5yji3wv"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const s=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",s)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const o=e.getAttribute("href"),r=e.getAttribute("target");o&&o!=="#"&&o!=="javascript:void(0)"&&(r==="_blank"?window.open(o,"_blank"):setTimeout(function(){window.location.href=o},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-rl8zheqs74c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rl8zheqs74c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iokgvzlkldm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iokgvzlkldm', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}